module.exports = __webpack_public_path__ + "static/media/W_Calendar_01.0b6c5e4c.png";